import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../Input/Button/Button';
import FGBLabel from '../FGBLabel/FGBLabel';
import './CallToActionComponent.scss';

export default class CallToActionComponent extends React.PureComponent {
    static propTypes = {
        /**
         * Orientation of icons
         */
        orientation: PropTypes.oneOf(['portrait', 'landscape']),
    };

    static defaultProps = {
        orientation: 'landscape',
        buttonText: 'Click Here',
    };

    render() {
        let component = null;
        if (this.props.orientation === 'landscape') {
            component = (
                <div className="landscape">
                    <FGBLabel>Find Out</FGBLabel>
                    <p className="white">
                        What are women saying about your company?
                    </p>
                    <div className="btnDiv">
                        <a href="/registration">
                            <Button
                                type="wired-white"
                                value={this.props.buttonText}
                            />
                        </a>
                    </div>
                </div>
            );
        } else {
            component = (
                <div className="portrait">
                    <div className="text-center">
                        <FGBLabel>Find Out</FGBLabel>
                        <p className="white">
                            What are women saying about your company?
                        </p>
                        <div className="btnDiv">
                            <a href="/registration">
                                <Button
                                    type="wired-white"
                                    value={this.props.buttonText}
                                />
                            </a>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="component-Elements-CallToActionComponent">
                {component}
            </div>
        );
    }
}
